import produce from 'immer';

import {
  DELETE_AGENT_SUCCESS,
  DELETE_VENDOR_SUCCESS,
  GET_AGENTS_SUCCESS,
  GET_COMMON_ADDRESS_SUCCESS,
  GET_RELOCATION_CONSULTANTS_FAILURE,
  GET_RELOCATION_CONSULTANTS_REQUEST,
  GET_RELOCATION_CONSULTANTS_SUCCESS,
  GET_VENDORS_SUCCESS,
  POST_AGENT_SUCCESS,
  POST_INTERNAL_USER_SUCCESS,
  POST_VENDOR_SUCCESS,
  PUT_AGENT_SUCCESS,
  PUT_INTERNAL_USER_SUCCESS,
  PUT_VENDOR_SUCCESS
} from './store/types';

import { remapUsers } from './utils';
import { GET_INTERNAL_USERS_SUCCESS } from 'modules/clients/types';

const initialState = {
  relocationConsultants: null,
  isLoading: false,
  internalUsers: null
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_RELOCATION_CONSULTANTS_REQUEST:
      draft.isLoading = true;
      break;

    case GET_RELOCATION_CONSULTANTS_FAILURE:
      draft.isLoading = false;
      break;

    case GET_RELOCATION_CONSULTANTS_SUCCESS:
      draft.relocationConsultants = remapUsers(action.response);
      draft.isLoading = false;
      break;

    case GET_INTERNAL_USERS_SUCCESS:
    case POST_INTERNAL_USER_SUCCESS:
    case PUT_INTERNAL_USER_SUCCESS:
      draft.internalUsers = action.response;
      break;

    case GET_VENDORS_SUCCESS:
    case PUT_VENDOR_SUCCESS:
    case POST_VENDOR_SUCCESS:
    case DELETE_VENDOR_SUCCESS:
      draft.vendors = action.response;
      break;

    case GET_AGENTS_SUCCESS:
    case PUT_AGENT_SUCCESS:
    case DELETE_AGENT_SUCCESS:
    case POST_AGENT_SUCCESS:
      draft.agents = action.response;
      break;

    case GET_COMMON_ADDRESS_SUCCESS:
      draft.commonAddress = action.response;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
